import { render, staticRenderFns } from "./MerchantDetailsHeader.vue?vue&type=template&id=2d2f6798&scoped=true&"
import script from "./MerchantDetailsHeader.vue?vue&type=script&lang=ts&"
export * from "./MerchantDetailsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantDetailsHeader.vue?vue&type=style&index=0&id=2d2f6798&scoped=true&lang=scss&"
import style1 from "./MerchantDetailsHeader.vue?vue&type=style&index=1&id=2d2f6798&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2f6798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VIcon,VImg,VSpacer})
